import React from 'react'
import ReactGA from 'react-ga'

const Filter = ({ onChange, status, selectedStatus, list }) => {
  let length = ''
  if (status === 'ALL') {
    length = list.length
  } else if (status === 'READY') {
    length = list.filter(data => data.status === 'READY').length
  } else if (status === 'OPEN') {
    length = list.filter(data => data.status === 'OPEN').length
  } else if (status === 'CLOSE') {
    length = list.filter(data => data.status === 'CLOSE').length
  } else if (status === 'HOLD') {
    length = list.filter(data => data.status === 'HOLD').length
  }

  return (
    <li className={status === selectedStatus ? 'status_item status_item_check' : 'status_item'} onClick={() => { ReactGA.event({ category: '건축주의 요청', label: '탭 메뉴', action: status + ' 클릭' }) }}>
      <label>
        <input type="radio" name="status" value={status} onChange={onChange} checked={status === selectedStatus} />
        {status} <span>{length}</span>
      </label>
    </li>
  )
}

const FilterList = ({ onChangeStatus, selectedStatus, list }) => {
  const statusArray = ['ALL', 'READY', 'OPEN', 'CLOSE', 'HOLD']

  const statusList = statusArray.map(
    (status, i) => (<Filter status={status} selectedStatus={selectedStatus} list={list} onChange={() => onChangeStatus(status)} key={i} />)
  )

  return (
    <ul className="status_list">
      {statusList}
    </ul>
  )
}

export default FilterList



// WEBPACK FOOTER //
// ./Src/Components/Demand/FilterList.js